import React, { useEffect, useState } from 'react'
import Menu from '@mui/material/Menu'
import Grow from '@mui/material/Grow'
import ContentFilter from '@mui/icons-material/FilterList'
import { Button, FilterButtonMenuItem, useListContext } from 'react-admin'
import { useMediaQuery, useTheme } from '@mui/material'
import { FilterButtonProps } from './type'

export const FilterButton: React.FC<FilterButtonProps> = ({ label, filters = [] }) => {
  const ListContext = useListContext()
  const { showFilter, resource, displayedFilters } = ListContext
  const [remainFilters, setRemainFilters] = useState(filters)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const ids = {
    button: `filter-button_${resource}`,
    menu: `filter-button_${resource}`,
  }

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleFilterShow = ({ source, defaultValue }): void => {
    showFilter(source, defaultValue)
    setAnchorEl(null)
  }

  const FilterMenuItems = remainFilters.map((input, index) => (
    <FilterButtonMenuItem
      key={`${input.props.source}-${index}`}
      onShow={handleFilterShow}
      filter={input}
      resource={resource}
    />
  ))

  useEffect(() => {
    setRemainFilters(
      filters.filter((input) => {
        const { source, alwaysOn } = input.props
        return !displayedFilters[source] && !alwaysOn
      }),
    )
  }, [displayedFilters, filters])

  if (remainFilters.length <= 0) return null

  return (
    <div>
      <Button
        size='medium'
        id={ids.button}
        aria-controls={open ? ids.menu : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        label={label || 'ra.action.add_filter'}
        onClick={handleClick}
        {...(!isSmall && { startIcon: <ContentFilter /> })}
      >
        {isSmall ? <ContentFilter /> : <></>}
      </Button>
      <Menu
        id={ids.menu}
        MenuListProps={{
          'aria-labelledby': ids.button,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Grow}
      >
        {FilterMenuItems}
      </Menu>
    </div>
  )
}
